"use client";
import { useEffect, useRef } from "react";

import { Modal } from "antd";

export const CustomModal = ({ open, className = "", ...rest }) => {
  const wasOpen = useRef(false);

  useEffect(() => {
    const body = document.body;

    const updateModalCount = (delta) => {
      const current = parseInt(body.dataset.modalCount || "0", 10);
      const next = Math.max(current + delta, 0);
      body.dataset.modalCount = next.toString();

      if (next > 0) {
        body.style.position = "fixed";
      } else {
        body.style.position = "";
      }
    };

    // when open becomes true
    if (open && !wasOpen.current) {
      updateModalCount(+1);
      wasOpen.current = true;
    }

    // when open becomes false
    if (!open && wasOpen.current) {
      updateModalCount(-1);
      wasOpen.current = false;
    }

    return () => {
      // when component unmounts while still open
      if (wasOpen.current) {
        updateModalCount(-1);
        wasOpen.current = false;
      }
    };
  }, [open]);

  return (
    <Modal
      open={open}
      className={`custom-modal ${className}`}
      centered
      transitionName=""
      getContainer={() => document.body}
      {...rest}
    />
  );
};
